import React from 'react';
import { JsonLd, Generic } from 'react-structured-data';
import GatsbyHead from './GatsbyHead';
// import NextHead from './NextHead'

const StructuredData = props => {
  /* GENERAL PAGES */
  /* if (defaultMicroData && !microDataType) {
        return (
            <JsonLd>
                <Generic type="webpage" jsonldtype="WebPage" schema={{
                    name: title, 
                    description: metaDescription
                }}/>
            </JsonLd>
        )
    } */

  /* HOMEPAGE */
  if (props.defaultMicroData && props.microDataType === 'home') {
    return (
      <JsonLd>
        <Generic
          type="store"
          jsonldtype="Store"
          schema={{
            name: props.title,
            url: typeof window !== 'undefined' && window.location.href,
            logo: `${process.env.SITE_URL}/logo.png`,
            telephone: '',
            priceRange: '$$$',
            image: `${process.env.SITE_URL}/logo.png`
          }}
        >
          <Generic
            type="potentialAction"
            jsonldtype="SearchAction"
            schema={{
              target: `${process.env.SITE_URL}/search/?q={search_term}`,
              'query-input': 'required name=search_term'
            }}
          />
          <Generic
            type="address"
            jsonldtype="PostalAddress"
            schema={{
              streetAddress: '',
              addressLocality: '',
              postalCode: '',
              addressCountry: ''
            }}
          />
        </Generic>
      </JsonLd>
    );
  }

  return null;
};

const Head = props => {
  const siteName = 'Pet Chemist Online';

  return (
    <>
      <GatsbyHead {...props} siteName={siteName}>
        {props.children}
      </GatsbyHead>
      {/**
       * GATSBY Rendering
       */}
      {/* {(process.env.GATSBY_ENABLED) ? (
                <>
                    <GatsbyHead {...props} siteName={siteName}>
                        {props.children}
                    </GatsbyHead>
                    <StructuredData {...props} />
                </>
            ) : (
                <StructuredData {...props} />
            )} */}

      {/**
       * NEXTJS Rendering
       */}
      {/* {(process.env.NEXT_PUBLIC_ENABLED) ? (
                <>
                    <NextHead {...props} siteName={siteName}>
                        {props.children}
                    </NextHead>
                    <StructuredData {...props} />
                </>
            ) : (
                <StructuredData {...props} />
            )} */}

      <StructuredData {...props} />
    </>
  );
};

export default Head;
